import { CityType } from "@smile2impress/location-content";
import { UTSLocale } from "@smile2impress/attraction-constants";

export const LOCALE_WITH_TWO_CITY_LISTS = [
    UTSLocale.GB_EN,
    UTSLocale.ITALY_IT,
    UTSLocale.PORTUGAL_PT,
];

export type CitiesListProps = {
    titleForFirstList: string;
    cities: CityType[];

    titleForSecondList?: string;
    titleForThirdList?: string;
    disclaimerForSecondList?: string;
    excludedCities?: string[];
};
